import type { ApplicationContext } from '@hc-frontend/core-context';
import { createErrorOperationResult } from '@hc-frontend/core-utils-business-operation';

import { UpdateProspectLeadIdParameters } from '../../entities';
import type {
  UpdateProspectLeadIdRepository,
  UpdateProspectLeadIdResult,
} from '../../repositories';

export type UpdateProspectLeadIdUseCase = (
  parameters: UpdateProspectLeadIdParameters,
) => Promise<UpdateProspectLeadIdResult>;

type UpdateProspectLeadIdFactoryParams = Pick<ApplicationContext, 'log'> & {
  provider: UpdateProspectLeadIdRepository;
};

export function updateProspectLeadIdFactory({
  provider,
  log,
}: UpdateProspectLeadIdFactoryParams): UpdateProspectLeadIdUseCase {
  return async (parameters) => {
    const convertResult = UpdateProspectLeadIdParameters.safeParse(parameters);

    if (!convertResult.success) {
      log({
        type: 'error',
        context: 'server',
        message: 'failedToUpdateProspectLeadId',
        data: {
          rootCause: convertResult.error,
        },
      });
      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToUpdateProspectLeadId',
            rootCause: convertResult.error,
          },
        ],
      });
    }

    const result = await provider.update(convertResult.data);

    if (!result.success) {
      log({
        context: 'server',
        type: 'error',
        message: result.errors[0].code,
        data: {
          rootCause: result.errors[0].rootCause,
        },
      });
    }

    return result;
  };
}
